// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tkddtpgqymivzddnfnrd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRrZGR0cGdxeW1pdnpkZG5mbnJkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMxMjU4OTksImV4cCI6MjA2ODcwMTg5OX0.JA3JY8U_DBO64wNXEnxNGJ5febGUvLmXeK2h3n5z0y0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});